<template>
    <div class="edit-assigned-screen">
        <div class="ea-topbar">
            <back-button />
        </div>

        <skeleton-loader v-if="loading" type="assigned-editor" />
        <assigned-routine-editor v-else-if="assignedRoutine" :default-routine="assignedRoutine" />
    </div>
</template>

<script>

import {getMergedBlocks} from "@/utils/Exercises";
import {db} from '@/utils/Firebase'
import BackButton from "@/components/common/BackButton";
import SkeletonLoader from "@/components/common/SkeletonLoader";
import AssignedRoutineEditor from "@/components/coach/routines/AssignedRoutineEditor";

export default {
    components: {
        AssignedRoutineEditor,
        SkeletonLoader,
        BackButton,
    },
    data() {
        return {
            loading: false,
            assignedRoutine: null
        }
    },
    async mounted() {
        const vm = this
        await vm.setDefaultRoutine()
    },
    methods: {
        async setDefaultRoutine() {
            const vm = this
            await vm.withLoading(async () => {
                const assignedRoutineRef = await db.collection('assignedRoutines').doc(vm.$route.params.uid).get()
                if (!assignedRoutineRef.exists) return
                let assignedRoutine = assignedRoutineRef.data()

                if (assignedRoutine.type === 'competence') {
                    vm.toast(vm.$t('routines.competence_not_editable_here'), 'error')
                    return vm.$router.back()
                }

                assignedRoutine.id = assignedRoutineRef.id
                assignedRoutine.blocks = await getMergedBlocks(assignedRoutine.blocks || [])
                vm.assignedRoutine = assignedRoutine
            })
        }
    }

}

</script>

<style scoped>

.ea-topbar {
    display: flex;
    align-items: center;
    padding: 4px 0 12px;
}

</style>
